import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Formik } from 'formik'
import { TextField } from 'src/Libs/inputs/formik'
import { Breakpoints } from 'src/Configuration/breakpoints'
import { useInviteEditorFormInitializer } from '../hooks'

const useStyles = makeStyles()(theme => ({
  description: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
}))

export interface CompanyInvite {
  email: string | undefined
}

export interface InviteFormType {
  email: string
}

export interface InviteEditorProps {
  place: number
  onClose: () => void
  onSave: (invite: CompanyInvite) => void
  size: Breakpoints
  title: string
  description?: string
}

const InviteEditor: React.FC<InviteEditorProps> = ({ place, onClose, onSave, size, title, description }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { initialValues, validationSchema } = useInviteEditorFormInitializer()

  const handleFormikSubmit = useCallback(
    (values: InviteFormType) => {
      onSave({ email: values.email })
      onClose()
    },
    [onClose, onSave]
  )

  return (
    <Formik initialValues={initialValues} onSubmit={handleFormikSubmit} validationSchema={validationSchema}>
      {({ isValid, dirty, handleSubmit }) => {
        return (
          <Dialog
            place={place}
            title={title}
            maxWidth={size}
            onClose={() => {
              onClose()
            }}
            actions={{
              secondary: [
                {
                  name: t('common.cancel'),
                  onClick: () => {
                    onClose()
                  },
                },
              ],
              primary: {
                name: t('user.company.invitation.addInvite'),
                disabled: !isValid || !dirty,
                onClick: handleSubmit,
              },
            }}
          >
            <Box className={classes.description}>{description && <Typography>{description}</Typography>}</Box>
            <TextField label={t('common.email')} name={'email'} />
          </Dialog>
        )
      }}
    </Formik>
  )
}

export default InviteEditor
